import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "./motion";

export const Faq = ({ overline = "Answers", title = "Frequently asked.", faqs }) => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="relative py-28 lg:py-40 bg-[#010101]">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <Reveal>
          <p className="text-xs tracking-[0.3em] uppercase text-[#fcc41b] font-display font-medium mb-6">{overline}</p>
          <h2 className="font-display font-semibold tracking-tighter leading-[0.95] text-white mb-16" style={{ fontSize: "clamp(2.25rem, 5.5vw, 4.5rem)" }}>
            {title}
          </h2>
        </Reveal>

        <div className="border-t border-[#1c1c1c]">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} className="border-b border-[#1c1c1c]">
                <button
                  data-testid={`faq-toggle-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-6 py-7 text-left group"
                >
                  <span className={`font-display font-medium text-lg lg:text-2xl transition-colors duration-300 ${isOpen ? "text-[#fcc41b]" : "text-white group-hover:text-zinc-300"}`}>
                    {f.q}
                  </span>
                  <motion.span animate={{ rotate: isOpen ? 45 : 0 }} transition={{ duration: 0.3 }} className="shrink-0 text-[#fcc41b]">
                    <Plus size={24} />
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="pb-8 pr-10 text-zinc-400 text-lg leading-relaxed">{f.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
